export default __webpack_public_path__ + "i18n/translations/translation-mr.875a7359.json";